<template>
  <div class="input-search">
    <el-autocomplete
      ref="input"
      v-model="childValue"
      class="inline-input"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      style="width: 100%"
      size="mini"
      :placeholder="isPlaceholder"
      @focus="focus"
      @keyup.native="tabCell"
      @select="handleSelect"
    >
      <i
        v-if="!search"
        slot="suffix"
        class="el-icon-search"
        @click="handleIconClick"
      />
      <i slot="suffix" class="el-icon-circle-close" @click="clear" />
    </el-autocomplete>
    <!-- <el-input
    v-model="childValue"
    :size="size"
    :disabled="disabled"
    @input="inputAction"
    @focus="focusAction"
    @blur="blurAction"
    @keyup.native="tabCell"
    clearable
    @clear="clear">
      <i
      slot="suffix"
      class="el-icon-search"
      @click="handleIconClick">
      </i>
    </el-input> -->
    <local-dialog-table
      ref="table"
      :title="title"
      :append-to-body="true"
      :visible.sync="visible"
      :req-config="reqConfig"
      :column-defs="gridOptions.columnDefs"
      :show-pagination="true"
      :radio="false"
      :required="false"
      :show-search="true"
      :custom-select="false"
      @selectChange="onSelectionChangedData"
      @afterFetch="afterFetch"
      @onSelect="onSelect"
    />
  </div>
</template>

<script>
import localDialogTable from '../DialogTable/index.js'
export default {
  name: 'AgInputSelect',
  components: { localDialogTable },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'mini'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否自动聚焦
    autoFocus: {
      type: Boolean,
      default: false
    },
    reqConfig: {
      type: Object,
      default: () => {
        return {
          url: '', // 接口api
          method: '', // 请求方法
          params: {}, // 请求参数
          keyword: '', // 查询关键字
          searchValue: '', // 搜索框默认值设置
          dataFormat: {}, // 数据格式
          updataUrl: false // 更新分页信息到路径上
        }
      }
    },
    gridOptions: {
      type: String,
      default: ''
    },
    search: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFocus: true,
      childValue: this.value,
      tableSelectData: [],
      allSelect: [],
      visible: false,
      // value: null,
      filterVal: [
        { value: '@{ALL}' },
        { value: '@{CURRENTUSER}' },
        { value: '@{CURRENTSTAFF}' },
        { value: '@{CURRENTORG}' },
        { value: '@{CURRENTROLE}' },
        { value: '@{CURRENTCUSTOMER}' },
        { value: '@{CURRENTCORP}' },
        { value: '@{CURRENTCOST}' }
      ]
    }
  },
  computed: {
    isPlaceholder() {
      return this.placeholder || this.$t('components.pleaseEnter')
    }
  },
  mounted() {
    // if (this.params && Object.keys(this.params).length > 0) this.childValue = this.params.value // （ag-grid中使用必须有）
    // // this.formatNum()
    // // 返回当前组件指向
    // this.mark && this.$emit('getComponent', this)
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        console.log('this.$refs.input', this.$refs.input)
        console.log('this.$refs.params', this.params)
      }
    })
  },
  // 销毁前触发失焦事件--解决ag-grid点击直接退出编辑状态情况
  beforeDestroy() {
    const pseudoEvent = {
      mark: 'pseudoEvent',
      target: {
        value: this.childValue
      }
    }
    this.blurAction(pseudoEvent)
  },
  methods: {
    focus() {},
    clear() {
      this.childValue = ''
    },
    handleIconClick(event) {
      this.isFocus = false
      event.preventDefault()
      this.visible = true
    },
    onSelectionChangedData(ref) {
      console.log('ref', ref)
      // 获取当前分页数据
      const pageNo = this.$refs.table.pagination.pageNo
      // 当前页选中值对象
      // const selectedNodes = ref.getSelectedNodes()
      ref.forEachNode((node, index) => {
        if (node.selected) {
          this.allSelect.push(node)
        } else {
          this.allSelect.map((item, index_) => {
            if (node.data.sId === item.data.sId) {
              this.allSelect.splice(index_, 1)
            }
          })
        }
      })
      this.allSelect = this.allSelect.length > 0 ? unique(this.allSelect) : []
      function unique(arr) {
        var i
        var j
        var len = arr.length
        for (i = 0; i < len; i++) {
          for (j = i + 1; j < len; j++) {
            if (arr[i].data.sId === arr[j].data.sId) {
              arr.splice(j, 1)
              len--
              j--
            }
          }
        }
        return arr
      }
      // 取出当前分页中所选中的值
      const selectedData =
        this.allSelect && this.allSelect.map((node) => node.data)
      this.tableSelectData[pageNo] = selectedData
      // 所有选中的值
      this.$refs.table.selectedRightDataNodes = [].concat.apply(
        [],
        selectedData
      )
    },
    afterFetch(rowData) {
      this.complete_Data = rowData
      console.log(rowData)
      this.$refs.table.gridOptions.api.forEachNode((node) => {
        const data = [].concat.apply([], this.tableSelectData)
        data.map((item) => {
          if (item[rowData.keyField] === node.data[rowData.keyField]) {
            node.setSelected(true)
          }
        })
      })
    },
    handleClose(value = []) {
      console.log('value', value)
      this.$emit('onSelect', value)
    },
    onSelect(option, type) {
      if (type === 'confirm') {
        const value = {
          option: option,
          data: this.complete_Data
        }
        this.$emit('change', value)
        this.$emit('saveVal', value)
      }
      // this.handleClose()
      this.allSelect = []
      this.arr = []
      this.visible = false
    },
    // 失焦事件
    blurAction(e) {
      // this.handleIconClick(true)
      this.$emit('input', this.childValue)
      this.$emit('blur', e)
    },
    tabCell(e) {
      if (!this.mark) return
      // 解决ag-grid编辑状态回车赋值以及计算问题
      if (e.keyCode === 13) {
        // const pseudoEvent = {
        //   mark: 'pseudoEvent',
        //   target: {
        //     value: this.childValue
        //   }
        // }
        // this.flagFocus && this.blurAction(pseudoEvent)
      }
      this.$emit('keyup', e)
    },
    getValue() {
      return this.childValue
    },
    querySearch(queryString, cb) {
      const filterVal = this.filterVal
      const results = queryString
        ? filterVal.filter(this.createFilter(queryString))
        : filterVal
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (filterVal) => {
        return (
          filterVal.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    handleSelect(item) {},

    isCancelBeforeStart() {
      return false
    },

    isCancelAfterEnd() {
      return false
    },
    isPopup() {
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.input-search {
  .el-icon-search,
  .el-icon-circle-close {
    cursor: pointer;
    margin: 0 1px;
  }
}
</style>
